import { render } from "./legoChip.vue?vue&type=template&id=24496010"
import script from "./legoChip.vue?vue&type=script&lang=js"
export * from "./legoChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoChip/legoChip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24496010"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24496010', __exports__)) {
    api.reload('24496010', __exports__)
  }
  
  module.hot.accept("./legoChip.vue?vue&type=template&id=24496010", () => {
    api.rerender('24496010', render)
  })

}


export default __exports__